import axios from "axios";

const API_PATH = '/manage/members';

const FetchSource = async searches => (
	await axios.get(API_PATH, { params: searches })
);

const FetchMemberView = async ({ id }) => (
	await axios.get(`${API_PATH}/${id}`)
);

const FetchMemberEvent = async searches => (
	await axios.get(`${API_PATH}/events`)
);

const FetchMemberExercise = async ({ id, source }) => (
	await axios.get(`${API_PATH}/${id}/exercise`, { params: source })
);

const FetchMemberPointHistory = async ({ id, source }) => (
	await axios.get(`${API_PATH}/${id}/points/history`, { params: source })
);

const GiveMemberPoint = async ({ mId, source }) => (
	await axios.post(`${API_PATH}/${mId}/points`, source)
);

export { FetchSource, FetchMemberView, FetchMemberEvent, FetchMemberExercise, FetchMemberPointHistory, GiveMemberPoint } ;
